import { useForm, usePage, Link } from "@inertiajs/react";
import AppLayout from "@/layout/AppLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ChevronLeft } from "lucide-react";

export default function TeamEdit() {
  const { team, errors: serverErrors = {} } = usePage().props;
  const form = useForm({
    name:        team.name        ?? "",
    label:       team.label       ?? "",
    description: team.description ?? "",
    note:        team.note        ?? "",
  });
  const errors = { ...serverErrors, ...form.errors };

  function submit(e) {
    e.preventDefault();
    form.patch(team.paths.update);
  }

  return (
    <AppLayout>
      <div className="container py-8 max-w-md mx-auto">
        <Button asChild variant="ghost" size="sm" className="mb-4 -ml-1 text-muted-foreground">
          <Link href={team.paths.show}>
            <ChevronLeft className="h-4 w-4" />
            Back to team
          </Link>
        </Button>

        <h1 className="text-2xl font-bold mb-6">Edit team</h1>

        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-1.5">
            <Label htmlFor="name">Team name <span className="text-destructive">*</span></Label>
            <Input
              id="name"
              autoFocus
              value={form.data.name}
              onChange={(e) => form.setData("name", e.target.value)}
            />
            {errors.name && <p className="text-xs text-destructive">{errors.name}</p>}
          </div>

          <div className="space-y-1.5">
            <Label htmlFor="label">Label <span className="text-muted-foreground font-normal text-xs">(optional short tag)</span></Label>
            <Input
              id="label"
              placeholder="e.g. Friday Crew, Work Lunch Group"
              value={form.data.label}
              onChange={(e) => form.setData("label", e.target.value)}
            />
            {errors.label && <p className="text-xs text-destructive">{errors.label}</p>}
          </div>

          <div className="space-y-1.5">
            <Label htmlFor="description">Description</Label>
            <textarea
              id="description"
              rows={2}
              placeholder="What games does your group play?"
              value={form.data.description}
              onChange={(e) => form.setData("description", e.target.value)}
              className="flex min-h-[60px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
            />
          </div>

          <div className="space-y-1.5">
            <Label htmlFor="note">Notes <span className="text-muted-foreground font-normal text-xs">(optional)</span></Label>
            <textarea
              id="note"
              rows={2}
              placeholder="Meeting time, house rules, anything the group should know…"
              value={form.data.note}
              onChange={(e) => form.setData("note", e.target.value)}
              className="flex min-h-[60px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
            />
          </div>

          <div className="flex gap-3">
            <Button type="submit" disabled={form.processing}>
              {form.processing ? "Saving…" : "Save changes"}
            </Button>
            <Button asChild variant="ghost">
              <Link href={team.paths.show}>Cancel</Link>
            </Button>
          </div>
        </form>
      </div>
    </AppLayout>
  );
}
